<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Trade name' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Name' | translate}}</label>
      <input type="text" class="form-control" [(ngModel)]="entity.name" />
    </div>

    <div class="form-group">
      <label>{{'Description' | translate}}</label>
      <ckeditor [editor]="Editor" [config]="editorConfig" class="editor_sm" [(ngModel)]="entity.description"></ckeditor>
    </div>

    <div class="form-group">
      <label>{{'Select new logo' | translate}}</label>

      <div class="image-cropper image-cropper-profile image-cropper-profile-company">

        <div class="row" *ngIf="entity.avatarUri">
          <div class="col-12 col-sm-6">
            {{'Current image' | translate}}
            <div class="current-image-wrapper">
              <img class="img-fluid image-current image-current-avatar" [src]="entity.avatarUri" />
            </div>
          </div>
        </div>

        <div class="row row-image-cropper row-image-cropper-avatar" [ngClass]="{'d-none' : !avatarFileName}">

          <div class="col-12 col-lg-6">

            <div class="image-cropper">
              <image-cropper
                [imageChangedEvent]="avatarImageChangedEvent"
                [maintainAspectRatio]="true"
                [aspectRatio]="1"
                format="png"
                output="base64"
                [roundCropper]="true"
                (imageCropped)="avatarImageCropped($event)"

                (cropperReady)="avatarCropperReady()"
                (loadImageFailed)="avatarLoadImageFailed()"
              ></image-cropper>
            </div>

          </div>

          <div class="col-12 col-lg-6">

            <div class="image-cropper-preview image-cropper-preview-circle">
              <img [src]="avatarCroppedImage" class="img-fluid" />
            </div>

          </div>

        </div>

        <div class="custom-file">
          <input type="file" class="custom-file-input" (change)="avatarFileChangeEvent($event)"  id="avatarFile">
          <label class="custom-file-label" for="avatarFile" [attr.data-browse]="'Select file' | translate">{{'Select new logo' | translate}}</label>
        </div>

      </div>

    </div>

    <div class="form-group">
      <label>{{'Select new cover image' | translate}}</label>

      <div class="image-cropper image-cropper-cover image-cropper-cover-company">

        <div class="row" *ngIf="entity.coverPhotoUri">
          <div class="col-12 col-sm-6">
            {{'Current image' | translate}}
            <div class="current-image-wrapper">
              <img class="img-fluid image-current image-current-cover" [src]="entity.coverPhotoUri" />
            </div>
          </div>
        </div>

        <div class="row row-image-cropper row-image-cropper-cover" [ngClass]="{'d-none' : !coverFileName}">

          <div class="col-12 col-lg-6">

            <div class="image-cropper">
              <image-cropper
                [imageChangedEvent]="coverImageChangedEvent"
                [maintainAspectRatio]="true"
                [aspectRatio]="3 / 1"
                format="png"
                output="base64"
                (imageCropped)="coverImageCropped($event)"

                (cropperReady)="coverCropperReady()"
                (loadImageFailed)="coverLoadImageFailed()"
              ></image-cropper>
            </div>

          </div>

          <div class="col-12 col-lg-6">

            <div class="image-cropper-preview">
              <img [src]="coverCroppedImage" class="img-fluid" />
            </div>

          </div>

        </div>

        <div class="custom-file">
          <input type="file" class="custom-file-input" (change)="coverFileChangeEvent($event)"  id="coverFile">
          <label class="custom-file-label" for="coverFile" [attr.data-browse]="'Select file' | translate">{{'Select new cover image' | translate}}</label>
        </div>

      </div>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">

      <button type="button" class="btn btn-secondary" (click)="activeModal.close(true)">{{'Cancel' | translate}}</button>

      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>

    </div>
  </div>
</div>
